// @ts-nocheck
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  InputLabel,
  Modal,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  closeSendSmsModalAction,
  closeSendSmsModalWithHistoryAction,
  closeSmsModalAction,
  fetchOlderSmsAction,
  fetchPeopleForSmsAction,
  sendSmsAction,
} from "../../store/actions/sms/sms";
import { EmailInputForUser } from "../EventDetails/ClientEmailInput";
import { CustomTextFiled } from "../Custom/Input";
import { alertDialogAciton } from "../../store/actions/auth";
import { CustomChip } from "../Custom/CustomIconButton";
import { USER_ROLES } from "../../staticData/userRoles";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { CustomNumberBadge } from "../NavBar/components/NotesBadge";
import { CustomTextButton } from "../Filter/ClearAllTextButton";
import { borderBottom, display } from "@mui/system";
import {
  deleteCustomMessage,
  getCustomMessages,
} from "../../store/actions/configurations";
import { CustomMessageOption } from "../../pages/event-request-details/components/SendOpportunities";
import { Close } from "@mui/icons-material";
import GenericTransparentBtn from "../Custom/GenericTransparentBtn";
import ReusableParentContainer from "../Custom/ReusableParentContainer";
import theme from "../../theme";

const style = {
  boxShadow: 24,
  p: 4,
  pb: 0,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  width: "500px",
  maxHeight: "90vh",
  // minWidth: "300px",
  maxWidth: "1000px",
  overflowY: "auto",
  transition: "all 0.3s ease",
  "@media (max-width: 600px)": {
    maxHeight: "97vh",
    maxWidth: "95vh",
  },
};

export const SmsEventModal = ({ isDM = false }) => {
  const customMessagesSearchListInit = useMemo(() => {
    return {
      data: [],
      filteredData: [],
      show: false,
      selectedMessage: null,
      isLoading: false,
    };
  }, []);
  const [customMessagesSearchList, setCustomMessagesSearchList] = useState(
    customMessagesSearchListInit,
  );
  const { eventInfo } = useSelector((state) => state?.eventRequestDetails);
  const { sendSmsModalStatus, isLoading, people, initialPeople } = useSelector(
    (state) => state?.smsReducer,
  );
  const dispatch = useDispatch();

  const initialValues = useMemo(() => {
    return {
      people: initialPeople || [],
      message: "",
    };
  }, [initialPeople]);

  function fetchMessagesTemplates() {
    dispatch(
      getCustomMessages({
        beforeCallback: () => {
          setCustomMessagesSearchList((customMessagesSearchList) => {
            return {
              ...customMessagesSearchList,
              isLoading: true,
            };
          });
        },
        afterCallback: () => {
          setCustomMessagesSearchList((customMessagesSearchList) => {
            return {
              ...customMessagesSearchList,
              isLoading: false,
            };
          });
        },
        successCallback: ({ res }) => {
          setCustomMessagesSearchList((customMessagesSearchList) => {
            return {
              ...customMessagesSearchList,
              data: res?.data?.data,
              filteredData: res?.data?.data,
            };
          });
        },
      }),
    );
  }

  useEffect(() => {
    if (!sendSmsModalStatus) return;
    fetchMessagesTemplates();
  }, [sendSmsModalStatus, dispatch]);

  // building options for sms
  const options = useMemo(() => {
    const peopleArr = Array.isArray(people) ? people : people?.users || [];
    return [
      ...(peopleArr?.map((item) => ({
        _id: item?._id,
        name: item?.preferredName
          ? item?.preferredName
          : item?.name
            ? item?.name
            : `${item?.firstName} ${item?.lastName}`,
        searchName: [
          item?.firstName,
          item?.lastName,
          item?.middleName,
          item?.name,
          item?.preferredName,
        ],
        email: item?.email,
        userRole:
          item?.userRole == USER_ROLES.SUPERADMIN
            ? USER_ROLES.ADMIN
            : item?.userRole,
        isGustoApproved: item?.isGustoApproved || false,
        isADPApproved: item?.isADPCompleted || false,
      })) || []),
    ];
  }, [people]);

  const optionsCategory = useMemo(() => {
    let category = {
      all: 0,
      ["Custom-Payroll"]: 0,
      ["Custom-HR"]: 0,
    };
    options?.forEach((item) => {
      if (!category?.[item?.userRole]) {
        category[item?.userRole] = 0;
      }

      category[item?.userRole] += 1;
      category["all"] += 1;

      if (!item?.isADPApproved && item?.userRole == USER_ROLES.CONTRACTOR) {
        category["Custom-Payroll"] += 1;
      }

      if (!item?.isGustoApproved && item?.userRole == USER_ROLES.CONTRACTOR) {
        category["Custom-HR"] += 1;
      }
    });

    return category;
  }, [options]);

  function onClose() {
    if (!isDM) {
      dispatch(closeSendSmsModalAction());
    } else {
      dispatch(closeSendSmsModalWithHistoryAction());
    }
    formik.resetForm();
  }

  const validationSchema = Yup.object().shape({
    people: Yup.array()
      .min(1, "There should be at least one person.")
      .required("People required to send sms"),
    message: Yup.string()
      .trim()
      .required("There should be some message.")
      .max(1000, "The message should be at most 1000 characters."),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      // A DM is a conversation with the PERSON, not with an event — so it must
      // not be stamped with one. `eventInfo` is global redux state that is only
      // cleared on navigation, so off an event page (Contractors, Big Search)
      // it still holds the LAST event opened: stamping it filed the text under
      // an unrelated event's SMS history. `eventId` is optional server-side
      // (sms.service.ts:288 writes `undefined` when absent), so dropping it is
      // safe — the log is then keyed by user only, which is what a DM is.
      const eventIdForSms = isDM ? undefined : eventInfo?._id;
      const userIds = values?.people?.map((i) => ({
        eventId: eventIdForSms,
        id: i?._id,
      }));
      dispatch(
        sendSmsAction({
          payload: {
            data: {
              userIds,
              content: values?.message,
            },
          },
          successCallback: (msg) => {
            resetForm();
            dispatch(
              fetchOlderSmsAction({
                payload: {
                  params: {
                    eventId: eventIdForSms,
                  },
                },
              }),
            );
            dispatch(closeSendSmsModalAction());
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Success",
                message: msg || "SMS sent successfully",
              }),
            );
          },

          failureCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Failure",
                message: msg || "Failed to send SMS",
              }),
            );
          },
        }),
      );
    },
  });

  const {
    values,
    setValues,
    handleChange,
    handleBlur,
    touched,
    submitForm,
    errors,
    setFieldValue,
  } = formik;

  useEffect(() => {
    setCustomMessagesSearchList((customMessagesSearchList) => {
      return {
        ...customMessagesSearchList,
        filteredData: customMessagesSearchList?.data?.filter?.((item) => {
          return item?.message
            ?.toLowerCase()
            ?.includes?.(values?.message?.toLowerCase?.());
        }),
      };
    });
  }, [values?.message]);

  useEffect(() => {
    if (customMessagesSearchList?.selectedMessage?._id) {
      setFieldValue(
        "message",
        customMessagesSearchList?.selectedMessage?.message,
      );
    }
  }, [customMessagesSearchList?.selectedMessage]);

  function addUsersToRecipients(userType, condition = null) {
    const exisingUser = new Set(values?.people?.map((item) => item?._id));
    const newUsers = options
      ?.map((i) => {
        if (!exisingUser?.has(i?._id) && userType == i?.userRole) {
          return i;
        } else if (
          userType?.split("-")?.[0] == "Custom" &&
          i?.userRole == USER_ROLES.CONTRACTOR &&
          condition != null &&
          !i?.[condition]
        ) {
          return i;
        } else {
          return null;
        }
      })
      ?.filter(Boolean);

    setValues((prev) => ({
      ...prev,
      people:
        userType == "all" ? options : [...(prev?.people || []), ...newUsers],
    }));
  }

  const buttonList = [
    {
      label: "Client",
      type: USER_ROLES.CLIENT,
    },
    {
      label: "Contractor",
      type: USER_ROLES.CONTRACTOR,
    },
    {
      label: "Coordinator",
      type: USER_ROLES.COORDINATOR,
    },
    {
      label: "Admin",
      type: USER_ROLES.ADMIN,
    },
    {
      label: "All",
      type: "all",
    },
    {
      label: "Not HR Approved",
      type: "Custom-HR",
      condition: "isGustoApproved",
      isInverse: true,
    },
    {
      label: "Not Payroll Approved",
      type: "Custom-Payroll",
      condition: "isADPApproved",
      isInverse: true,
    },
  ];

  function handlePersonDelete({ person }) {
    setValues((prev) => ({
      ...prev,
      people: prev?.people?.filter((i) => i?._id !== person?._id),
    }));
  }

  const categorisedUsers = useMemo(() => {
    let final = {};
    values?.people?.map((item) => {
      if (!final[item?.userRole]) {
        final[item?.userRole] = [];
      }
      final?.[item?.userRole]?.push(item);
    });
    return final;
  }, [values?.people]);

  return (
    <Modal
      open={sendSmsModalStatus}
      onClose={onClose}
      sx={{
        zIndex: 2000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          ...style,
          display: "flex",
          justifyContent: "flex-start",
          aliginItems: "flex-start",
          gap: "1rem",
          flexDirection: "column",
          overflowY: "visible",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "1.25rem",
              paddingBottom: "1rem",
              fontWeight: "500",
            }}
          >
            Send Text Message
          </Typography>

          {!isDM ? (
            <>
              <Typography sx={{ paddingBottom: "0.25rem" }}>
                Select recipients to send SMS:
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  pb: 1,
                }}
              >
                {buttonList?.map((bt) => {
                  return (
                    <CustomChip
                      style={{
                        borderRadius: "0.75rem",
                        backgroundColor: "transparent",
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-rgb",
                        }),
                        border: "1px solid",
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-rgb",
                        }),
                      }}
                      key={bt?.type}
                      label={
                        <Typography
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "0.25rem",
                            color: getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            }),
                          }}
                        >
                          {bt?.label}
                          <Typography
                            sx={{
                              color: "inherit",
                              border: "1px solid",
                              height: "18px",
                              fontSize: "0.75rem",
                              minWidth: "18px",
                              px: "0.25rem",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "50%",
                              borderColor: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                            }}
                          >
                            {optionsCategory?.[bt?.type]}
                          </Typography>
                        </Typography>
                      }
                      onClick={() =>
                        addUsersToRecipients(bt?.type, bt?.condition)
                      }
                    />
                  );
                })}
              </Box>
              <Box
                sx={{
                  padding: values?.people?.length == 0 ? "0" : "0.5rem",
                  border: values?.people?.length == 0 ? "none" : "1px solid",
                  borderRadius: "0.5rem",
                  borderColor: getCssVariableHandler({
                    variableName: "--white-rgb",
                  }),
                }}
              >
                <EmailInputForUser
                  disableAdd
                  disableError
                  hideEmailFromTag
                  errorMsg={"Select at least one user to send sms"}
                  values={[]}
                  name={"people"}
                  handleBlur={handleBlur}
                  setValues={(list) => {
                    const previousPeopleValue =
                      values?.people?.length > 0
                        ? values?.people?.map((i) => i?._id)
                        : [];
                    if (previousPeopleValue?.includes(list?.[0]?._id)) {
                      dispatch(
                        alertDialogAciton({
                          open: true,
                          title: "Error",
                          message: "This user is already added to list",
                        }),
                      );
                      return;
                    }
                    setFieldValue("people", [
                      ...(values?.people || []),
                      list?.[0],
                    ]);
                  }}
                  options={options}
                  placeholder={"Search users"}
                />
                {/* list of available people category wise */}
                <Box
                  sx={{
                    display: values?.people?.length == 0 ? "none" : "block",
                    maxHeight: "40vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                  className="custom-scroll-design"
                >
                  <DividerBorder />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "1.05rem",
                        fontWeight: "500",
                      }}
                    >
                      Selected Users:{" "}
                      <CustomNumberBadge number={values?.people?.length} />
                    </Typography>
                    <Box>
                      <CustomTextButton
                        sx={{
                          display: "flex",
                        }}
                        text={"Remove all"}
                        onClick={() => setFieldValue("people", [])}
                      />
                    </Box>
                  </Box>
                  {Object.keys(categorisedUsers)?.map((category, i) => {
                    if (categorisedUsers?.[category]?.length > 0) {
                      return (
                        <Box
                          key={category}
                          sx={{
                            display: "flex",
                            gap: "0.25rem",
                            flexDirection: "column",
                          }}
                        >
                          <DividerBorder disable={i == 0} width={"75%"} />
                          <Typography>
                            Selected{" "}
                            {
                              buttonList?.find((i) => i?.type == category)
                                ?.label
                            }
                            :
                            <CustomNumberBadge
                              number={categorisedUsers?.[category]?.length}
                            />
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              gap: "0.25rem",
                              flexWrap: "wrap",
                            }}
                          >
                            {categorisedUsers?.[category]?.map((person) => (
                              <CustomChip
                                avatar={
                                  <Avatar
                                    sx={{
                                      width: 24,
                                      height: 24,
                                      fontSize: "0.8rem",
                                    }}
                                  >
                                    {person?.name?.[0]}
                                  </Avatar>
                                }
                                key={person?._id}
                                label={person?.name}
                                onDelete={() => handlePersonDelete({ person })}
                              />
                            ))}
                          </Box>
                        </Box>
                      );
                    }
                    return null;
                  })}
                </Box>
              </Box>
              {errors?.people && touched?.people && (
                <Typography color="red">{errors?.people}</Typography>
              )}
            </>
          ) : (
            <Box>
              <Typography>
                Recipient:{" "}
                <Typography
                  sx={{ fontWeight: "500", color: theme.palette.green.main }}
                  component={"span"}
                >
                  {values?.people?.[0]?.name}
                </Typography>
              </Typography>
            </Box>
          )}

          <Box mt={2}>
            <InputLabel>Message:</InputLabel>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                marginTop: "auto",
                alignSelf: "flex-end",
              }}
            >
              {customMessagesSearchList?.show ? (
                <ReusableParentContainer
                  style={{
                    position: "absolute",
                    height: "auto",
                    transform: "translateY(100px)",
                    top: "0",
                    left: "0",
                    width: "100% !important",
                    background: getCssVariableHandler({
                      variableName: "--bg-theme-rgb",
                    }),
                    padding: "0.5rem !important",
                    zIndex: "9",
                    borderColor: getCssVariableHandler({
                      variableName: "--white-rgb",
                    }),
                    "@media (max-width: 600px)": {
                      overflowY: "auto !important",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "150px",
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                      zIndex: "20",
                    }}
                    className={"custom-scroll-design"}
                  >
                    {customMessagesSearchList?.isLoading ? (
                      <CircularProgress sx={{ my: "1rem" }} size={22} />
                    ) : customMessagesSearchList?.filteredData?.length > 0 ? (
                      customMessagesSearchList?.filteredData?.map?.(
                        (customMessage) => {
                          return (
                            <React.Fragment key={customMessage?._id}>
                              <CustomMessageOption
                                option={customMessage}
                                onMouseDown={() => {
                                  setValues((prev) => ({
                                    ...prev,
                                    message: customMessage?.message,
                                  }));
                                  setCustomMessagesSearchList(
                                    (customMessagesSearchList) => {
                                      return {
                                        ...customMessagesSearchList,
                                        selectedMessage: customMessage,
                                      };
                                    },
                                  );
                                }}
                                selectedCustomMessage={
                                  customMessagesSearchList?.selectedMessage
                                }
                                sx={{
                                  borderBottom: "1px solid gray",
                                  padding: "0.25rem",
                                }}
                                showDelete
                                allowSelect={false}
                                deleteFunc={() => {
                                  dispatch(
                                    alertDialogAciton({
                                      open: true,
                                      title: "Warning",
                                      message:
                                        "Are you sure, you want to delete this template?",
                                      okLabel: "Delete",
                                      onOk: () => {
                                        dispatch(
                                          deleteCustomMessage({
                                            params: {
                                              messageId: customMessage?._id,
                                            },
                                            failureCallback: ({ error }) => {
                                              dispatch(
                                                alertDialogAciton({
                                                  open: true,
                                                  title: "Error!",
                                                  message:
                                                    error?.response?.data
                                                      ?.message ||
                                                    "Some error occured!",
                                                }),
                                              );
                                            },
                                            successCallback: () => {
                                              fetchMessagesTemplates();
                                            },
                                          }),
                                        );
                                      },
                                    }),
                                  );
                                }}
                              />
                            </React.Fragment>
                          );
                        },
                      )
                    ) : customMessagesSearchList?.data?.length === 0 &&
                      !customMessagesSearchList?.isLoading &&
                      values?.message?.trim() !== "" ? (
                      <Typography sx={{ my: "1rem" }}>
                        No custom messages found
                      </Typography>
                    ) : null}
                  </Box>
                </ReusableParentContainer>
              ) : null}
              <CustomTextFiled
                sx={{
                  height: "auto !important",
                }}
                fullWidth
                name="message"
                value={values?.message}
                onBlur={(e) => {
                  handleBlur(e);
                  setTimeout(() => {
                    setCustomMessagesSearchList((customMessagesSearchList) => {
                      return {
                        ...customMessagesSearchList,
                        show: false,
                      };
                    });
                  }, 50);
                }}
                onChange={handleChange}
                placeholder={"Write your message here"}
                multiline
                rows={3}
                onFocus={() => {
                  setCustomMessagesSearchList((customMessagesSearchList) => {
                    return {
                      ...customMessagesSearchList,
                      show: true,
                    };
                  });
                }}
              />
            </Box>
            {errors?.message && touched?.message && (
              <Typography color="red">{errors?.message}</Typography>
            )}
          </Box>

          <Box
            className="bottom-btn-box"
            sx={{
              width: "100%",
              marginTop: "2rem",
              alignSelf: "flex-end",
              marginBottom: " 2rem",
            }}
          >
            <Button
              className="btn-black"
              sx={{
                width: "50%",
                height: "3.25rem",
                textTransform: "none !important",
              }}
              onClick={onClose}
            >
              <Typography className="btn-text">Close</Typography>
            </Button>

            <Button
              className="btn-pink"
              sx={{
                width: "50%",
                height: "3.25rem",
                textTransform: "none !important",
                "&:disabled": {
                  background: "#d85ad8 !important",
                },
              }}
              onClick={submitForm}
            >
              {isLoading ? (
                <CircularProgress size={22} />
              ) : (
                <Typography sx={{ whiteSpace: "nowrap" }} className="btn-text">
                  Send
                </Typography>
              )}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

function DividerBorder({ width = "90%", disable = false }) {
  if (disable) {
    return null;
  }
  return (
    <Divider
      orientation="horizontal"
      sx={{
        borderColor: getCssVariableHandler({
          variableName: "--white-rgb",
        }),
        my: "0.5rem",
        mx: "auto",
        width,
      }}
    />
  );
}
DividerBorder.propTypes = {
  width: PropTypes.string,
  disable: PropTypes.bool,
};

SmsEventModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  successCb: PropTypes.func,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  pageName: PropTypes.string,
  isDM: PropTypes.bool,
};